"use strict";
import { fiatOnRampToCurrency, gqlToCurrency } from "graphql/data/util";
import { COMMON_BASES, buildPartialCurrencyInfo } from "constants/uniswapRouting";
import { USDC_OPTIMISM } from "constants/topazTokenList";
import {
  ProtectionResult,
  SafetyLevel
} from "data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { isUniverseChainId } from "features/chains/types";
import { TokenList } from "features/dataApi/types";
import { buildCurrencyInfo, getCurrencySafetyInfo } from "features/dataApi/utils";
import { isSameAddress } from "utilities/src/addresses";
import { currencyId } from "utils/currencyId";
export function gqlTokenToCurrencyInfo(token) {
  if (!token) {
    return void 0;
  }
  const currency = gqlToCurrency(token);
  if (!currency) {
    return void 0;
  }
  const currencyInfo = buildCurrencyInfo({
    currency,
    currencyId: currencyId(currency),
    logoUrl: token.project?.logo?.url ?? token.project?.logoUrl,
    isSpam: token.project?.isSpam ?? false,
    safetyInfo: getCurrencySafetyInfo(token.project?.safetyLevel ?? SafetyLevel.StrongWarning, token.protectionInfo)
  });
  return currencyInfo;
}
export function meldSupportedCurrencyToCurrencyInfo(forCurrency) {
  if (!isUniverseChainId(Number(forCurrency.chainId))) {
    return void 0;
  }
  const supportedChainId = Number(forCurrency.chainId);
  const commonBases = COMMON_BASES[supportedChainId];
  const currencyInfo = commonBases.find((base) => {
    if (base.currency.isNative) {
      return !forCurrency.address;
    }
    return isSameAddress(base.currency.address, forCurrency.address);
  });
  if (currencyInfo) {
    return {
      ...currencyInfo,
      logoUrl: forCurrency.symbol,
      safetyInfo: {
        tokenList: TokenList.Default,
        protectionResult: ProtectionResult.Benign
      },
      isSpam: false
    };
  }
  if (isSameAddress(forCurrency.address, "0x7f5c764cbc14f9669b88837ca1490cca17c31607")) {
    return buildPartialCurrencyInfo(USDC_OPTIMISM);
  }
  const currency = fiatOnRampToCurrency(forCurrency);
  if (!currency) {
    return void 0;
  }
  return buildCurrencyInfo({
    currency,
    currencyId: currencyId(currency),
    logoUrl: forCurrency.symbol,
    safetyInfo: {
      tokenList: TokenList.Default,
      protectionResult: ProtectionResult.Benign
    },
    isSpam: false
  });
}
